import React, { Fragment } from "react";
import styled from 'styled-components';
import I10n from '../../../features/i10n';
import MsxIcons from '../../msx-icons';
import { SECONDARY_COLOR } from "../../../color-constants";
import Button from "../../../atoms/button";
import { getLicenceModelComparator } from "./ducks";
import Skeleton from "../../../components/skeleton";

const Container = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  min-width: 95%;
  width: 95%;
  max-width: 95%;
  max-height: 95%;
  background-color: white;
  color: #333333;
  padding: 20px;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
`;

const HeaderTitle = styled.span`
  font-size: 24px;
  font-weight: 700;
`;

const Content = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding-top: 10px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`;

const ComparatorTable = styled.table`
  min-width: 100%;
  max-width: 100%;
`;

const ComparatorHeader = styled.thead``;

const ComparatorBody = styled.tbody``;

const ComparatorTableHeaderRow = styled.tr`
  td:first-child {
    position: sticky;
    z-index: 1;
    left: 0;
  }
`;

const ComparatorHeaderCell = styled.th`
  ${props => props.width ? `
    min-width: ${props.width}%;
    width: ${props.width}%;
    max-width: ${props.width}%;
  ` : ''}
`;

const ComparatorTableRow = styled.tr`
  td:first-child {
    position: sticky;
    z-index: 1;
    left: 0;
  }
`;

const ComparatorItemRow = styled.tr`
  border-bottom: 1px solid #D9D9D9;
  td:first-child {
    position: sticky;
    z-index: 1;
    left: 0;
  }
`;

const ComparatorTableCell = styled.td`
  vertical-align: middle;
  background-color: white;
`;

const ComparatorTableCellGrey = styled(ComparatorTableCell)`
  background-color: #f4f4f4;
`;

const ComparatorGroupTitleCellContent = styled.div`
  padding: 10px 0px;
`;

const ComparatorTableCellContent = styled.div`
  padding: 10px;
`;

const CenteredComparatorTableCellContent = styled(ComparatorTableCellContent)`
  display: flex;
  justify-content: center;
  white-space: pre-wrap;
  text-align: center;
`;

const ComparatorTitle = styled.span`
  font-size: 24px;
  font-weight: 700;
`;

const ComparatorValueGroupTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
`;

const ComparatorItemTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #333333;
`;

const ComparatorItemLabel = styled.span`
  font-size: 16px;
  font-weight: 400;
`;

const ComparatorIconWrapper = styled.div`
  min-width: 32px;
  width: 32px;
  max-width: 32px;
  min-height: 32px;
  height: 32px;
  max-height: 32px;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
`;

const COMPARATOR_VALUE_TYPES = {
  TEXT: 'text',
  ICON: 'icon'
};

const VALUE_ICON_MAPPING = {
  CHECK: 'check'
};

class ModalCompareLicenseModels extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      licenseModelCategories: [],
      licenseModelComparatorGroups: [],
      isLoading: false
    }

    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true
    this.updateStateIfMounted({isLoading: true});
    getLicenceModelComparator(this.props.softwareSelection).then((result) => {
      this.updateStateIfMounted({licenseModelCategories: result.licenseModelCategories,
        licenseModelComparatorGroups: result.licenseModelComparatorGroups});
    }).catch(() => {})
    .finally(() => {
      this.updateStateIfMounted({isLoading: false});
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  renderComparatorTitleRow() {
    return (
      <ComparatorTableRow>
        <ComparatorTableCell></ComparatorTableCell>
        {this.state.licenseModelCategories.map((category, idx) => {
          return (<ComparatorTableCell key={idx}>
            <CenteredComparatorTableCellContent>
              <ComparatorTitle>{I10n.getOrDefault(`screen.licence_selector.license_model_comparator_category.name.${category.licenseModelCategoryKey}`, category.value)}</ComparatorTitle>
            </CenteredComparatorTableCellContent>
        </ComparatorTableCell>); })}
      </ComparatorTableRow>
    );

  }

  renderValueIcon(value) {
    let renderFunction = () => <ComparatorItemLabel>ERR</ComparatorItemLabel>;
    const mapTypeToRenderFunction = {
      [VALUE_ICON_MAPPING.CHECK]: () => {
        return <ComparatorIconWrapper>
          <MsxIcons name="done-stroke" size="medium"></MsxIcons>
        </ComparatorIconWrapper>;
      }
    }

    if (mapTypeToRenderFunction[value]) {
      renderFunction = mapTypeToRenderFunction[value];
    }

    return renderFunction();
  }

  renderComparatorItemValue(comparatorItem) {
    let renderFunction = () => <ComparatorItemLabel>ERR</ComparatorItemLabel>;
    const mapTypeToRenderFunction = {
      [COMPARATOR_VALUE_TYPES.TEXT]: () => {
        return <ComparatorItemLabel>{I10n.getOrDefault(`screen.licence_selector.license_model_comparator_value.name.${comparatorItem.labelKey}`, comparatorItem.value)}</ComparatorItemLabel>;
      },
      [COMPARATOR_VALUE_TYPES.ICON]: () => {
        return this.renderValueIcon(comparatorItem.value);
      }
    }

    if (mapTypeToRenderFunction[comparatorItem?.type]) {
      renderFunction = mapTypeToRenderFunction[comparatorItem.type];
    }

    return renderFunction();
  }

  renderComparatorValueGroup(comparatorValueGroup, nbColumns) {
    return (
      <>
        {comparatorValueGroup.value && <ComparatorTableRow>
          <ComparatorTableCell colSpan={nbColumns}>
            <ComparatorGroupTitleCellContent>
              <ComparatorValueGroupTitle>{I10n.getOrDefault(`screen.licence_selector.license_model_comparator_item.name.${comparatorValueGroup.licenseModelComparatorGroupKey}`, comparatorValueGroup.value)}</ComparatorValueGroupTitle>
            </ComparatorGroupTitleCellContent>
          </ComparatorTableCell>
        </ComparatorTableRow>}
        {comparatorValueGroup.comparatorItems.map((comparatorItem, idx) => {
          return (
            <ComparatorItemRow key={idx}>
              <ComparatorTableCellGrey>
                <ComparatorTableCellContent>
                  <ComparatorItemTitle>
                    {I10n.getOrDefault(`screen.licence_selector.license_model_comparator_item.name.${comparatorItem.licenseModelComparatorItemKey}`, comparatorItem.value)}
                  </ComparatorItemTitle>
                </ComparatorTableCellContent>
              </ComparatorTableCellGrey>
              {this.state.licenseModelCategories.map((category, idx) => {
                return (
                  <ComparatorTableCell key={idx}>
                    <CenteredComparatorTableCellContent>
                      {this.renderComparatorItemValue(category.comparatorValues?.[comparatorItem.licenseModelComparatorItemKey])}
                    </CenteredComparatorTableCellContent>
                  </ComparatorTableCell>
                );
              })}
            </ComparatorItemRow>
          );
        })}
      </>
    );
  }


  renderTable() {
    const nbColumns = (this.state.licenseModelCategories.length + 1);
    const headerElements = [<ComparatorHeaderCell width={100.0 / nbColumns}></ComparatorHeaderCell>];
    this.state.licenseModelCategories.forEach(() => {
      headerElements.push(<ComparatorHeaderCell width={100.0 / nbColumns}></ComparatorHeaderCell>);
    });

    return (
      <ComparatorTable>
        <ComparatorHeader>
          <ComparatorTableHeaderRow>
            {headerElements.map((elt, idx) => {
              return (
                <Fragment key={idx}>
                  {elt}
                </Fragment>
              );
            })}
          </ComparatorTableHeaderRow>
        </ComparatorHeader>
        <ComparatorBody>
          {this.renderComparatorTitleRow()}
          {this.state.licenseModelComparatorGroups.map((comparatorValueGroup, idx) => {
            return (
              <Fragment key={idx}>
                {this.renderComparatorValueGroup(comparatorValueGroup, nbColumns)}
              </Fragment>
            );
          })}


        </ComparatorBody>
      </ComparatorTable>
    );
  }

  render = () => {
    return (
      <Container>
        <Header>
          <HeaderTitle>{I10n.get('screen.licence_selector.how_are_they_different')}</HeaderTitle>
        </Header>
        <Content>
            {this.state.isLoading ? <Skeleton nbCols={2} expand={true}></Skeleton> : this.renderTable()}
        </Content>
        <Footer>
          <Button onClick={() => {
            this.props.closeModal();
          }}>{I10n.get('app.action.close')}</Button>
        </Footer>
      </Container>
    );
  }
}

export default ModalCompareLicenseModels;
